import * as Actions from "../actions";

const initialState = {
  sprints: [],
  isSprintsLoading: false,
  sprintTickets: [],
  isSprintTicketsLoading: false,
  sprintTicketsError: null,

  ticketsByDateRange: [],
  ticketsByDateRangeError: null,
  ticketDetails: {},
  ticketDetailsError: null,
  loadingTickets: {}, 
  projects: [],
  projectBoard: null,
  kanbanTickets: [],
};

const sprintReducer = function (state = initialState, action) {
  switch (action.type) {
    case Actions.GET_SPRINTS:
      return {
        ...state,
        sprints: action.payload,
      };

    case Actions.IS_SPRINTS_LOADING:
      return {
        ...state,
        isSprintsLoading: action.payload,
      };

    case Actions.GET_SPRINT_TICKETS:
      return {
        ...state,
        sprintTickets: action.payload,
        isSprintTicketsLoading: false,
        sprintTicketsError: null,
      };

    case Actions.IS_SPRINT_TICKETS_LOADING:
      return {
        ...state,
        isSprintTicketsLoading: action.payload,
      };

    case Actions.GET_SPRINT_TICKETS_ERROR:
      return {
        ...state,
        isSprintTicketsLoading: false,
        sprintTicketsError: action.payload,
      };

    case Actions.GET_TICKETS_BY_DATE_RANGE_LOADING:
      return {
        ...state,
        ticketsByDateRange: null,
        ticketsByDateRangeError: null,
        loading: true,
      };

    case Actions.GET_TICKETS_BY_DATE_RANGE:
      return {
        ...state,
        ticketsByDateRange: action.payload,
        ticketsByDateRangeError: null,
        loading: false,
      };

    case Actions.GET_TICKETS_BY_DATE_RANGE_ERROR:
      return {
        ...state,
        ticketsByDateRangeError: action.payload,
        loading: false,
      };

    case Actions.GET_TICKET_DETAILS_LOADING:
      return {
        ...state,
        loadingTickets: {
          ...state.loadingTickets,
          [action.payload]: true,
        },
        ticketDetailsError: null,
      };
    
    case Actions.GET_PROJECTS:
      return {
        ...state,
        projects: action.payload,
      };

    case Actions.GET_PROJECT_BOARD:
      return {
        ...state,
        projectBoard: action.payload,
      };

    case Actions.GET_KANBAN_TICKETS:
      return {
        ...state,
        kanbanTickets: action.payload,
      };

    case Actions.GET_TICKET_DETAILS:
      return {
        ...state,
        ticketDetails: {
          ...state.ticketDetails,
          [action.payload.ticketId]: action.payload.data,
        },
        loadingTickets: {
          ...state.loadingTickets,
          [action.payload.ticketId]: false,
        },
        ticketDetailsError: null,
      };

    case Actions.GET_TICKET_DETAILS_ERROR:
      return {
        ...state,
        ticketDetailsError: action.payload.error,
        loadingTickets: {
          ...state.loadingTickets,
          [action.payload.ticketId]: false,
        },
      };

    default:
      return state;
  }
};

export default sprintReducer;
